import { Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import { DnDialogService } from '../../../_modules/dn-dialog/dn-dialog.service';
import { DailySignInService } from '../../../components/dialogs/daily-sign-in/daily-sign-in.service';
import { UserService } from '../../../_service/user/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sign-in-expanded',
  templateUrl: './sign-in-expanded.component.html',
  styleUrls: ['./sign-in-expanded.component.scss']
})
export class SignInExpandedComponent implements OnInit, OnChanges {
  @Input()
  signInData;
  @Input()
  hide = true;
  signed = false;
  value = 0;
  @Input()
  isLoading;
  @Input()
  userId;

  constructor(
    private dnDialogService: DnDialogService,
    private signInService: DailySignInService,
    private userService: UserService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.signed = this.signInData.bonus_status === 1 ? true : false; // 初始化获取Input
  }

  ngOnChanges(changes: SimpleChanges) {
   // console.log(changes)
    if (changes.hide) {
      if (this.hide === false) {
        this.signInService.signedStatus.subscribe(signed => {
          // console.log(signed);
          if (signed) { // 已签到后 新获取
            // this.readNewData();
            // this.getRewardValue();
          }
        });
      }
    }

    if (!!changes.signInData && !!this.signInData) {
      this.signed = this.signInData.bonus_status === 1 ? true : false; // Input改变后获取(修正Input数据的不正确)
      // this.getRewardValue();
    }
    if (changes.userId) {
      if (!!this.userId) { // 用户已退出或未登陆
        this.signed = false;
      }
    }
  }

  openSignIn() {
    if (!!this.userId) {
      // 网页重新启用签到
      this.signInService.setState(this.signInData);
      this.dnDialogService.open('daily-sign-in-dialog');

      // 引导下载APP签到弹窗。非网页端需注释掉，使用上面的打开原来的签到弹窗
      // this.dnDialogService.open('not-allow-daily-sign-in');
    } else {
      this.login();
    }
  }

  login() {
    this.userService.showLoginDialog(true);
  }

  getRewardValue() {
    if (this.signInData.count_day !== 0) {
      const index = this.signInData.count_day - 1;
      this.value = this.signInData.bonus_list[index].coin;
    }
  }

  readNewData() {
    this.signInService.newData.subscribe(state => {
      this.signInData = state;
      this.signed = this.signInData.bonus_status === 1 ? true : false;
    });
  }

  openRule() {
  }

  navTo(link) {
    // console.log(link);
    // if(link === 'daily_quest') {
    //   this.router.navigate(['/user/welfare'], { queryParams: {cid: '2'} });
    // } else if(link === 'inv_welfare') {
    //   this.router.navigate(['/user/welfare'], { queryParams: {cid: '0'} });
    // }
    this.router.navigate(['/user/index']);
  }

}
